export const GET_ALL_ARTICLES_API_SUCCESS = 'GET_ALL_ARTICLES_API_SUCCESS';
export const GET_SINGLE_ARTICLE_API_SUCCESS = 'GET_SINGLE_ARTICLE_API_SUCCESS';
export const GET_HELP_ARTICLE_TITLES_API_SUCCESS = 'GET_HELP_ARTICLE_TITLES_API_SUCCESS';
export const ADD_HELP_FORM_DATA_SUCCESS = 'ADD_HELP_FORM_DATA_SUCCESS';
export const EMPTY_HELP_FORM_DATA_SUCCESS = 'EMPTY_HELP_FORM_DATA_SUCCESS';
